// RadioButtonControlView
import { View } from 'backbone';
import eventBus from 'EventBus';

import BaseControlView from 'BaseControlView';
import constants        from "Constants";
import template from 'common-inputs/control_radio_button.ejs';
//=====================================================================
//
// An instance of this view represents a radio button control.
//
// Maty Rocha, February, 8 2016
//
//=====================================================================
class RadioButtonControlView extends BaseControlView  {

    initialize( opts ) {
        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = 'pf-radio-button';
        this.propViews = opts.propViews;

        if (!this.model.get('name')) {
            this.model.set('name', 'Name', {silent: true});
        }

        if (!this.model.get('value')) {
            this.model.set('value', 1, {silent: true});
        }

        if (!this.model.get('label')) {
            this.model.set('label', 'Radio Button', {silent: true});
        }

        if (!this.model.get('isSelected')) {
            this.model.set('isSelected', false, {silent: true});
        }

        this.listenTo( eventBus, 'CheckboxThemeChange', this.themeChangeRender);

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);

        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'RadioButtonControlView'
    get kind() {
        return 'RadioButtonControlView';
    }


}

export default RadioButtonControlView;

